import { useTranslation } from "react-i18next";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import arrow from "../../../assets/images/icons/arrow-down.svg";
import BluePhoneIcon from "../../../assets/images/icons/blue-phone.svg";
import { GeneralButton } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { useAppMediaQuery, useGetData } from "../../../hooks";
import ServiceProviderProfileSidebar from "./ServiceProviderProfileSidebar";

const ServiceProviderProfile = () => {
  const { t } = useTranslation();
  const { isMobileOrTablet } = useAppMediaQuery();
  const location = useLocation();
  const currentLocationParams = new URLSearchParams(location.search);
  const provider = currentLocationParams.get("provider");

  const isDoctorProfile = provider != "0" && !!provider;
  const { Id } = useParams();
  const { data, isLoading } = useGetData<any>(
    isDoctorProfile
      ? EndPoints.GetProviderProfile
      : EndPoints.GetFacilityProfile,
    {},
    Id,
  );
  const profileData = data?.Data;

  // Get current route path
  const currentPath = location.pathname.split("/").pop() || "";
  const hasCertificateId = location.pathname.includes("/certificates/");

  // Get the doctor certificates page title
  const doctorCertificatesTitle = isMobileOrTablet
    ? t("certificates")
    : t("doctor_certificates");

  // Get page title from translation key
  const getPageTitle = (path: string) => {
    const translationKey = path.replaceAll("-", "_");
    return Number.isInteger(Number(translationKey))
      ? t("doctor_info")
      : t(translationKey);
  };

  return (
    <div className="flex h-full flex-wrap gap-4 lg:flex-nowrap">
      <ServiceProviderProfileSidebar
        isLoading={isLoading}
        profileData={profileData}
      />
      <div className="box w-full space-y-4 overflow-auto">
        <div className="flex flex-wrap items-center justify-between gap-4">
          {/* Breadcrumb */}
          <nav aria-label="breadcrumb">
            <ol className="flex items-center">
              {hasCertificateId ? (
                <>
                  <li>
                    <Link
                      to={`certificates?provider=${provider}`}
                      className="text-body-text hover:underline"
                    >
                      {doctorCertificatesTitle}
                    </Link>
                  </li>
                  <li className="flex items-center">
                    <img
                      src={arrow}
                      alt="arrow"
                      className="mx-2 rotate-90 ltr:-rotate-90"
                    />
                    <span className="font-bold">
                      {t("certificate_of_medical")}
                    </span>
                  </li>
                </>
              ) : (
                currentPath && (
                  <li className="font-bold">{getPageTitle(currentPath)}</li>
                )
              )}
            </ol>
          </nav>
          <div className="flex items-center gap-3">
            <GeneralButton
              disabled={!profileData?.CanCall}
              color={isDoctorProfile ? "lite" : "blue"}
              className="!bg-primary-click !py-2.5"
              onClick={() =>
                window.location.replace(`tel: ${profileData?.CallNumber}`)
              }
              icon={isDoctorProfile ? BluePhoneIcon : undefined}
              title={isDoctorProfile ? t("call_the_doctor") : t("call_now")}
            />
          </div>
        </div>
        <>
          <Outlet context={profileData} />
        </>
      </div>
    </div>
  );
};

export default ServiceProviderProfile;
